<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="SKU名称">
                <a-input v-model="queryParam.skuName" placeholder="请输入SKU名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
        @change="handleTableChange"
      >
        <span slot="shopPrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="salePrice" slot-scope="text, record">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="goodsName" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="skuName" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="merchantPrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="giftPoint" slot-scope="text, record">
          <a-switch
            checked-children="是"
            un-checked-children="否"
            :checked="text === 1"
            @change="(checked) => handleGiftPointChange(checked, record)"
          />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:inventory:merchantQueryList']">
            <a-icon type="eye" />详情
          </a>
          <a-divider type="vertical" />
          <a @click="handleSetPrice(record)" v-hasPermi="['retail:inventory:setPrice']">
            <a-icon type="setting" />设置价格
          </a>
          <a-divider type="vertical" />
          <a @click="handleViewMerchantPrice(record)" v-hasPermi="['retail:inventory:merchantPrice']">
            <a-icon type="bank" />商家价格
          </a>
        </span>
      </a-table>
    </a-card>

    <!-- 库存详情弹窗 -->
    <a-modal
      title="库存详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="detailVisible = false"
      width="800px"
    >
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="商品名称">{{ currentDetail.goodsName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="SKU名称">{{ currentDetail.skuName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="商家拿货价(元)">{{ currentDetail.merchantPrice || '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="门店拿货价(元)">{{ currentDetail.shopPrice || '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="门店销售价(元)">{{ currentDetail.salePrice || '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="PLUS会员价(元)">{{ currentDetail.plusPrice || '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="可用库存">{{ currentDetail.stock || 0 }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
      </a-descriptions>
    </a-modal>

    <!-- 设置价格弹窗 -->
    <a-modal
      title="设置价格"
      :visible="priceVisible"
      :confirm-loading="priceLoading"
      @ok="handlePriceSubmit"
      @cancel="priceVisible = false"
      width="500px"
    >
      <a-form-model :model="priceForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="商品名称">
          <a-input v-model="priceForm.goodsName" disabled />
        </a-form-model-item>
        <a-form-model-item label="SKU名称">
          <a-input v-model="priceForm.skuName" disabled />
        </a-form-model-item>
        <a-form-model-item label="商家拿货价">
          <a-input v-model="priceForm.merchantPrice" disabled />
        </a-form-model-item>
        <a-form-model-item label="门店拿货价" required>
          <a-input-number
            v-model="priceForm.shopPrice"
            :min="0"
            :precision="2"
            :step="0.01"
            style="width: 100%"
            placeholder="请输入门店拿货价"
          />
        </a-form-model-item>
        <a-form-model-item label="门店销售价" required>
          <a-input-number
            v-model="priceForm.salePrice"
            :min="0"
            :precision="2"
            :step="0.01"
            style="width: 100%"
            placeholder="请输入门店销售价"
          />
        </a-form-model-item>
        <a-form-model-item label="PLUS会员价" required>
          <a-input-number
            v-model="priceForm.plusPrice"
            :min="0"
            :precision="2"
            :step="0.01"
            style="width: 100%"
            placeholder="请输入PLUS会员价"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 商家价格弹窗 -->
    <a-modal
      title="商品商家价格"
      :visible="merchantPriceVisible"
      :footer="null"
      @cancel="merchantPriceVisible = false"
      width="800px"
    >
      <a-table
        :loading="merchantPriceLoading"
        :columns="merchantPriceColumns"
        :data-source="merchantPriceList"
        :pagination="false"
        :bordered="true"
      >
        <span slot="shopPrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '-' }}
        </span>
        <span slot="salePrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '-' }}
        </span>
      </a-table>
      <a-empty v-if="!merchantPriceLoading && merchantPriceList.length === 0" description="暂无商家价格数据" />
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getMerchantInventoryList, setShopAndSalePrice, getGoodsMerchantPrice, setGiftPoint } from '@/api/retail/inventory'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'MerchantInventory',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      currentDetail: null,
      priceVisible: false,
      priceLoading: false,
      merchantPriceVisible: false,
      merchantPriceLoading: false,
      merchantPriceList: [],
      priceForm: {
        inventoryId: null,
        goodsId: null,
        skuId: null,
        goodsName: '',
        skuName: '',
        merchantPrice: '',
        shopPrice: null,
        salePrice: null,
        plusPrice: null,
        giftPointChecked: false
      },
      queryParam: {
        goodsName: undefined,
        skuName: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '30', '50', '100']
      },
      merchantPriceColumns: [
        {
          title: '商家名称',
          dataIndex: 'orgName',
          width: 150,
          align: 'center'
        },
        {
          title: '门店拿货价(元)',
          dataIndex: 'shopPrice',
          width: 130,
          scopedSlots: { customRender: 'shopPrice' },
          align: 'center'
        },
        {
          title: '门店销售价(元)',
          dataIndex: 'salePrice',
          width: 130,
          scopedSlots: { customRender: 'salePrice' },
          align: 'center'
        }
      ],
      columns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'goodsName' },
          align: 'center'
        },
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'skuName' },
          align: 'center'
        },
        {
          title: '商家拿货价(元)',
          dataIndex: 'merchantPrice',
          width: 130,
          scopedSlots: { customRender: 'merchantPrice' },
          align: 'center'
        },
        {
          title: '门店拿货价(元)',
          dataIndex: 'shopPrice',
          width: 130,
          scopedSlots: { customRender: 'shopPrice' },
          align: 'center'
        },
        {
          title: '门店销售价(元)',
          dataIndex: 'salePrice',
          width: 130,
          scopedSlots: { customRender: 'salePrice' },
          align: 'center'
        },
        {
          title: 'PLUS会员价(元)',
          dataIndex: 'plusPrice',
          width: 130,
          scopedSlots: { customRender: 'salePrice' },
          align: 'center'
        },
        {
          title: '参与赠送积分',
          dataIndex: 'giftPoint',
          width: 110,
          scopedSlots: { customRender: 'giftPoint' },
          align: 'center'
        },
        {
          title: '可用库存',
          dataIndex: 'stock',
          width: 100,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 280,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParam,
        current: this.pagination.current,
        size: this.pagination.pageSize
      }
      getMerchantInventoryList(params).then(response => {
        if (response.data && response.data.records) {
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else if (Array.isArray(response)) {
          this.list = response
          this.pagination.total = response.length
        } else if (response.data && Array.isArray(response.data)) {
          this.list = response.data
          this.pagination.total = response.data.length
        } else {
          this.list = []
          this.pagination.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        goodsName: undefined,
        skuName: undefined
      }
      this.pagination.current = 1
      this.getList()
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    },
    handleDetail(record) {
      this.currentDetail = record
      this.detailVisible = true
    },
    handleSetPrice(record) {
      this.priceForm = {
        inventoryId: record.id,
        goodsId: record.goodsId,
        skuId: record.skuId,
        goodsName: record.goodsName || '',
        skuName: record.skuName || '',
        merchantPrice: record.merchantPrice ? parseFloat(record.merchantPrice).toFixed(2) : '0.00',
        shopPrice: record.shopPrice || null,
        salePrice: record.salePrice || null,
        plusPrice: record.plusPrice || null,
        giftPointChecked: record.giftPoint === 1
      }
      this.priceVisible = true
    },
    handlePriceSubmit() {
      if (!this.priceForm.shopPrice && this.priceForm.shopPrice !== 0) {
        this.$message.error('请输入门店拿货价')
        return
      }
      if (!this.priceForm.salePrice && this.priceForm.salePrice !== 0) {
        this.$message.error('请输入门店销售价')
        return
      }

      this.priceLoading = true
      const params = {
        inventoryId: this.priceForm.inventoryId,
        goodsId: this.priceForm.goodsId,
        skuId: this.priceForm.skuId,
        shopPrice: this.priceForm.shopPrice,
        salePrice: this.priceForm.salePrice,
        plusPrice: this.priceForm.plusPrice,
        giftPoint: this.priceForm.giftPointChecked ? 1 : 0
      }

      setShopAndSalePrice(params).then(() => {
        this.$message.success('设置成功')
        this.priceVisible = false
        this.getList()
      }).finally(() => {
        this.priceLoading = false
      })
    },
    handleGiftPointChange(checked, record) {
      const giftPoint = checked ? 1 : 0
      setGiftPoint({
        inventoryId: record.id,
        goodsId: record.goodsId,
        skuId: record.skuId,
        giftPoint: giftPoint
      }).then(() => {
        record.giftPoint = giftPoint
        this.$message.success('赠送积分设置已保存，将同步至该商家名下所有门店')
      }).catch(() => {
        this.getList()
      })
    },
    handleViewMerchantPrice(record) {
      this.merchantPriceVisible = true
      this.merchantPriceLoading = true
      const params = {
        goodsId: record.goodsId,
        skuId: record.skuId
      }
      getGoodsMerchantPrice(params).then(response => {
        this.merchantPriceList = response || []
        this.merchantPriceLoading = false
      }).catch(() => {
        this.merchantPriceLoading = false
      })
    }
  }
}
</script>

<style scoped>
.gift-point-tip {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.5;
  margin-top: 4px;
}
</style>
